module.exports = __webpack_public_path__ + "static/img/echarts6.b7066730.png";